<p-dialog [style]="{minWidth: '450px', minHeight: '295px'}" [closeOnEscape]="false" [closable]="false" header="{{dialogTitle}}" [(visible)]="displayDialog" [responsive]="true" showEffect="fade" [modal]="true" appendTo="body">
  <div class="grid">
    <div class="col-3">
      <label>Party Name</label>
    </div>
    <div class="col-9">
      <label>{{selectedName}}</label>
    </div>
  </div>

  <div class="grid">
    <div class="col-3">
      <label>Party Type</label>
    </div>
    <div class="col-9">
      <label>{{selectedType}}</label>
    </div>
  </div>

  <div class="grid">
    <div class="col-3">
      <label>Profile</label>
    </div>
    <div class="col-9">
      <p-dropdown hideDropdownOnScroll dataKey="id" optionLabel="name" [(ngModel)]="selectedProfile" [options]="profiles" appendTo="body" placeholder="Profile" [style]="{'width': '100%'}"></p-dropdown>
    </div>
  </div>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix admin-form">
      <button type="button" [disabled]="!allowActions" pButton icon="fa-fw fa fa-check" (click)="save()" label="Save"></button>
      <button type="button" [disabled]="!allowActions" pButton icon="fa-fw fa fa-close" (click)="cancel()" label="Cancel"></button>
    </div>
  </p-footer>
</p-dialog>
